/**
 * @copyright 汽车商贸管理平台 V1.0
 * @year 2026
 * @file tools.js
 */
const tools = {
  /* 判断值是否为空 */
  isEmpty(value) {
    return (
      value === undefined ||
      value === null ||
      (typeof value === "object" && Object.keys(value).length === 0) ||
      (typeof value === "string" && value.trim().length === 0)
    );
  },
  /* 判断值不为空 */
  isNotEmpty(value) {
    if (
      value === undefined ||
      value === null ||
      (typeof value === "object" && Object.keys(value).length === 0) ||
      (typeof value === "string" && value.trim().length === 0)
    )
      return false;
    else return true;
  },
  /**
   * 通用js方法封装处理
   */
  // 转换字符串，undefined,null等转化为""
  praseStrEmpty(str) {
    if (!str || str == "undefined" || str == "null") {
      return "";
    }
    return str;
  },

  //验证手机号
  isPoneNumber(str) {
    var myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
    if (!myreg.test(str)) {
      return false;
    } else {
      return true;
    }
  },
  //格式化日期
  formatDate(date) {
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    var day = date.getDate();
    if (month < 10) {
      month = "0" + month;
    }
    if (day < 10) {
      day = "0" + day;
    }
    var nowDate = `${year}年${month}月${day}日`;
    return nowDate;
  },

  /**
   * 判断年龄
   * @param {*} UUserCard
   * @returns
   */
  getAgeForIdCard(UUserCard) {
    //获取年龄
    var myDate = new Date();
    var month = myDate.getMonth() + 1;
    var day = myDate.getDate();
    var age = myDate.getFullYear() - UUserCard.substring(6, 10) - 1;
    if (
      UUserCard.substring(10, 12) < month ||
      (UUserCard.substring(10, 12) == month &&
        UUserCard.substring(12, 14) <= day)
    ) {
      age++;
    }
    return age;
  },

  // 身份证获得性别
  getSexForIdCard(idCard) {
    var sexStr = "";
    if (parseInt(idCard.slice(-2, -1)) % 2 == 1) {
      sexStr = "男";
    } else {
      sexStr = "女";
    }
    return sexStr;
  },
  //判断身份证
  isIdCard(idCard) {
    let reg = /^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
    if (reg.test(idCard)) {
      return true;
    } else {
      return false;
    }
  },

  //身份证获取生日
  getBirthdayForIdCard(idCard) {
    var birthday = "";
    if (idCard != null && idCard != "") {
      if (idCard.length == 15) {
        birthday = "19" + idCard.substr(6, 6);
      } else if (idCard.length == 18) {
        birthday = idCard.substr(6, 8);
      }

      birthday = birthday.replace(/(.{4})(.{2})/, "$1-$2-");
    }

    return birthday;
  },

  getBirthday(endTime) {
    // 将 2022-01-01 包含“-”符号的替换成“/”（兼容iOS时间戳转换成null的bug）
    var dateTime = endTime.replace(/-/g, "/");

    var endtimes = new Date(this.dateTime).getTime();
    var nowtimes = new Date().getTime();
    if (endtimes > nowtimes) {
      //如果结束时间大于当前时间 没有到期
      return true;
    } else {
      return false;
    }
  },

  //通过时间戳的方式来
  //var day =  parseInt（总秒数/60/60/24）;//天
  // var  t  =  parseInt（总秒数/60/60%24）;//时
  // var  m  =  parseInt（总秒数/60%60）;//分
  // var  s  =  parseInt（总秒数%60）;//秒
  countDown(inputTime) {
    var days = parseInt(mss / (1000 * 60 * 60 * 24));
    var hours = parseInt((mss % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    var minutes = parseInt((mss % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = (mss % (1000 * 60)) / 1000;
    return days + " 天 " + hours + " 小时 " + minutes + " 分钟 ";
  },

  //获取当前时间的周一至周日时间（一周所在的日期）
  getWeekDay(presentDate) {
    let today = presentDate.getDay() !== 0 ? presentDate.getDay() : 7;
    console.log(today);
    return Array.from(new Array(7), function(val, index) {
      return formatDates(
        new Date(
          presentDate.getTime() - (today - index - 1) * 24 * 60 * 60 * 1000
        )
      );
    });
    function formatDates(date) {
      return (
        date.getFullYear() +
        "-" +
        (date.getMonth() + 1) +
        "-" +
        date.getDate() +
        " 00:00:00"
      );
    }
  },
};

export default tools;
